import { FC, useRef } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { MediaCardCompilation } from '@shared/ui/Layout/Cards/MediaCardCompilation'
import { TypeMappingSelectionOutput } from '@shared/api/middleware/mappingAPI/selection/type'
import { useAppSelector } from '@app/model/store/client'
import { useIntersectionAnalytic } from '@shared/lib/hooks/useIntersectionAnalytic'
import { EGG } from '@shared/api/analytics'
import { useClientReady } from '@shared/lib/hooks/useClientReady'
import { PickAnalytic } from '@shared/api/analytics/types/types'

// D-desktop - M-mobile
// type size = 'D1x1 D2x1 M1x1'
interface Props {
  data: TypeMappingSelectionOutput
  sizes: string
  className?: string
  analytic: PickAnalytic<'section_index' | 'section_name'>
  deferImage?: boolean
}

const SelectionCardCompilation: FC<Props> = ({
  data,
  sizes,
  analytic,
  className = '',
  deferImage = false,
  ...props
}) => {
  const storeCurrentCitySlug = useAppSelector((state) => state.global.currentCity?.slug) ?? 'msk'
  const cardRef = useRef<HTMLDivElement | null>(null)
  const imagesReady = useClientReady()

  const handleClick = () => EGG.entity.selection.card_click(data, analytic)
  useIntersectionAnalytic(cardRef, () => EGG.entity.selection.card_view(data, analytic))

  return (
    <BlockBoundary>
      <MediaCardCompilation
        id={String(data.id)}
        title={data.description.title}
        sizes={sizes}
        img={{
          horizontal: data.img.sizes.desktop.horizontal,
          vertical: data.img.sizes.desktop.vertical,
        }}
        link={`/${storeCurrentCitySlug}/restaurants/${data.url.slug}`}
        chevron={data.categories.selection}
        promo={data.categories.advert.active}
        className={className}
        hideImage={deferImage && !imagesReady}
        onClick={handleClick}
        ref={cardRef}
        favorite={{
          category: 'selection',
          analytic: {
            data: data,
            other: {
              section_name: analytic.section_name,
            },
          },
        }}
        {...props}
      />
    </BlockBoundary>
  )
}

export default SelectionCardCompilation
